export const CLINIC_NAME = "AlamCareRx";
export const CLINIC_EMAIL = "support@alamcarerx.com";
export const CLINIC_PHONE = "+92 343 5447588";
export const CLINIC_PHONE_TEL = "+923435447588";
export const CLINIC_PHONE_WHATSAPP = "923435447588";
export const CLINIC_ADDRESS =
  "Shop #03 (Ground Floor), Building #139, Hub commercial, Bahria Town Phase 8, Rawalpindi";

export const DEFAULT_DOCTOR_DETAILS =
  "Registered Medical Practitioner\n1 year clinical intern at Accredited Hospital of Shihezi University School of medicine, China\n1 year house job holy family hospital , rawalpindi";
